/* eslint-disable array-bracket-spacing */
/* eslint-disable react/jsx-no-bind */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import {
  Container,
  Row,
  Col,
  Form,
  FormGroup,
} from 'reactstrap';
import { stopInterval } from '../../auth/validate-session';
import { login } from '../../actions/auth';
import graphic from '../../static/img/cm-landing.svg';
import { Highlight } from '../../guide';
import { withRouterProps } from '../../common/hocs';
// components
import { LoaderButton, CaptchaFrame } from '../../common/components';
import TextInput from '../common/TextInput';
import { loadLeadStatusOptions } from '../../actions/lead_status';

function Landing({
  dispatch,
  navigate,
  wasExpired,
  greeting,
  site,
  useCaptcha,
}) {
  const [ email, setEmail ] = useState(process.env.REACT_APP_LOGIN_USERNAME || '');
  const [ password, setPassword ] = useState(process.env.REACT_APP_LOGIN_PASSWORD || '');

  const [ captchaSolved, setCaptchaSolved ] = useState();
  const [ captchaVisible, setCaptchaVisible ] = useState();

  const [ loginLoading, setLoginLoading ] = useState();
  const [ loginError, setLoginError ] = useState();

  useEffect(() => {
    dispatch({ type: 'CLEAR' });
    document.body.className = 'bg-landing';

    // Stop checking for sesssion validation on login page.
    stopInterval();

    // Load any existing redux error into state, then clear cache
    if (wasExpired) {
      setLoginError('Your session has expired.');
      dispatch({ type: 'CLEAR_AUTH_EXPIRED' });
    }
  }, []);

  function authorizeUser() {
    setLoginLoading(true);
    login({ username: email, password }).then(() => {
      loadLeadStatusOptions().then(config => {
        dispatch({ type: 'LOAD_LEAD_STATUS_OPTIONS', payload: config });
      });
      navigate('/main');
    }).catch(({ message }) => {
      setLoginLoading(false);
      setLoginError(message);
      setCaptchaVisible(false);
    });
  }

  function handleLogin() {
    const hasValidationErrors = Boolean(!email || !password);
    if (hasValidationErrors) {
      if (!email) setLoginError('Email address required');
      if (!password) setLoginError('Password required');
    } else if (!captchaSolved && !hasValidationErrors && useCaptcha) {
      setCaptchaVisible(true);
    } else if ((captchaSolved || !useCaptcha) && !hasValidationErrors) {
      authorizeUser();
    }
  }

  const url = process.env.REACT_APP_MMB_API_URL;
  const siteUrl = process.env.REACT_APP_HOSTNAME || window.location.hostname;
  const captchaUrl = `${url}/api/token-auth/captcha/?site=${siteUrl}`;

  return (
    <Container fluid className="bg-dark">
      <Row>
        <Col
          lg={{ size: 4, offset: 2 }}
          xs={{ size: 10, offset: 1 }}
          className="d-flex flex-column justify-content-center my-6 pe-0"
        >
          <div className="mx-md-6 ms-lg-0 me-lg-5 me-xl-6">
            <Highlight id="landing" i={0} className="mb-5">
              <h1 className="text-white font-weight-bold text-lg-left text-center mb-0">
                {greeting}
              </h1>
            </Highlight>
            <Highlight id="landing" i={1}>
              {!captchaVisible
                ? (
                  <Form className="d-flex flex-column">
                    <FormGroup>
                      <TextInput
                        value={email}
                        setValue={setEmail}
                        setErrors={() => {}}
                        placeholder="Email address"
                        type="email"
                        onEnter={handleLogin}
                      />
                    </FormGroup>
                    <FormGroup>
                      <TextInput
                        value={password}
                        setValue={setPassword}
                        placeholder="Password"
                        type="password"
                        className="mb-0"
                        toggleVisibility
                        onEnter={handleLogin}
                      />
                    </FormGroup>
                    <div>
                      <LoaderButton
                        text="Login"
                        className="btn btn-primary w-100"
                        onClick={handleLogin}
                        loading={loginLoading}
                        disabled={loginLoading}
                      />
                    </div>
                    {loginError && (
                      <div className="mb-2 mt-1 fw-bold text-small text-danger">
                        {loginError}
                      </div>
                    )}
                    <div className="mt-3">
                      <a
                        // eslint-disable-next-line max-len
                        href={`${process.env.REACT_APP_MMB_API_URL}/reg/password_reset/?site=${site}&linkback=${window.location.hostname}`}
                        className="text-lightblue"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Password Reset
                      </a>
                    </div>
                  </Form>
                )
                : null}
              <CaptchaFrame
                src={captchaUrl}
                onSolve={authorizeUser}
                setSolved={() => setCaptchaSolved(true)}
                visible={captchaVisible}
                style={{
                  backgroundColor: 'white',
                  position: 'relative',
                  zIndex: '10',
                  borderRadius: '25px',
                }}
              />
            </Highlight>
          </div>
        </Col>
        <Col className="d-none d-lg-block align-self-center p-0">
          <img src={graphic} alt="" />
        </Col>
      </Row>
    </Container>
  );
}

const mapStateToProps = (store) => ({
  greeting: store.theme.greeting,
  wasExpired: store.auth.expired,
  site: store.theme.site,
  useCaptcha: store.theme.useCaptcha,
});

export default connect(mapStateToProps)(withRouterProps(Landing));
